<template>
    <div class="body back-gray">
        <div class="wrap txt-center intro">
            <h1 class="mt-20">
                듣기 음량 테스트
            </h1> 
            <p class="mt-20 font-16">Part Ⅴ는 대화를 듣고 요약하기 입니다.<br>테스트 전 소리 볼륨을 확인해주세요.</p>
            <div class="mt-60">
               <!-- 클릭 전 -->
                <span style="cursor: pointer;" v-if="!is_play" @click="playMp3()"><img src="../../assets/images/listen02.png" alt=""></span>
                <!-- 클릭 후 -->
                <span style="cursor: pointer;" v-if="is_play" @click="stopMp3()"><img src="../../assets/images/listen.gif" alt=""></span>
                <p class="font-16 bold txt-point mt-20">클릭하면 소리가 나옵니다.</p>
            </div>
        </div>        
        <div class="wrap">
            <div class="btn-fixed">
                <button class="btn-full" @click="next()">NEXT</button>
            </div>
        </div>
        <!-- 푸터 -->
        <Footer></Footer>
    </div>
</template>
<script>
import Footer from '@/components/footer.vue';
export default {
    name: 'Setting04',
    components: {
        Footer
    },
    data: () => ({
        guide_info:{},
        is_play:false,
        mp3:"",
        tts:null,
        type:""
    }),
    mounted() {
        this.getModule();
    },
    methods: {
        stopMp3(){
            if(this.tts.paused){
                this.tts.play();
                this.is_play = true;
                this.tts.addEventListener('ended',()=>{
                    this.is_play = false;
                });
            }else{
                this.is_play = false;
                this.tts.pause();
            }
        },
        playMp3(){
            console.log(this.tts);
            if(this.tts.paused){
                this.tts.play();
                this.is_play = true;
                this.tts.addEventListener('ended',()=>{
                    this.is_play = false;
                });
                console.log(this.mp3);
            }else{
                this.tts.pause();
                this.is_play = false;
            }
        },
         getModule(){
           var params = {
               idx : sessionStorage.getItem("student_idx")
           }
           this.axios.get(this.axios.root + "/rest/module_info/getModuleInfos",{params:params}).then((res)=>{
                if(res.data.err == 0){
                    // this.mp3 = this.axios.root + res.data.module_info.guide_info[4].mp3_url;
                    this.mp3 = this.axios.root + "/carrotdata/volumn_check.mp3";
                    this.tts = new Audio(this.mp3);
                    this.type = res.data.module_info.type;
                }else if(res.data.err == 5000){
                    alert(res.data.err_msg);
                    sessionStorage.clear();
                    location.href="/intro";
                }else{
                    alert(res.data.err_msg);
                    return false;
                }
           })
        },
        next(){
            this.tts.pause();
            this.tts.currentTime = 0;
            this.$router.push('/test_start/'+this.type);
        }
    }
}
</script>